import { render, staticRenderFns } from "./MoleculeEditionBillingMyShoppingModalPendingPayMethodsChange.vue?vue&type=template&id=5a4b8141"
import script from "./MoleculeEditionBillingMyShoppingModalPendingPayMethodsChange.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingMyShoppingModalPendingPayMethodsChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports